import { Button } from "@spz/ui/components/button";
import { InlineSpinner } from "@spz/ui/components/inline-spinner";
import { Typography } from "@spz/ui/components/typography";
import { cn } from "@spz/ui/lib/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface OnboardingSuccessProps {
  className?: string;
  redirectPath?: string;
  redirectDelay?: number;
}

export const OnboardingSuccess = ({
  className,
  redirectPath = "/controls",
  redirectDelay = 4000, // 4 seconds
}: OnboardingSuccessProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Handle automatic redirect
  useEffect(() => {
    const redirectTimeout = setTimeout(() => {
      navigate(redirectPath);
    }, redirectDelay);

    return () => {
      clearTimeout(redirectTimeout);
    };
  }, [navigate, redirectPath, redirectDelay]);

  const handleManualRedirect = () => {
    navigate(redirectPath);
  };

  return (
    <div
      className={cn(
        "flex flex-col justify-center h-full",
        "p-6 lg:p-8 xl:p-12",
        "max-w-2xl mx-auto w-full",
        "justify-center",
        className,
      )}
    >
      <div className="flex flex-col font-base">
        <InlineSpinner className="mb-6" size="large" />

        <Typography variant="h3" className="mb-4">
          {t("congrats_account_created")}
        </Typography>

        <Typography className="text-gray-700">
          {t("redirection_text")}
          <Button
            variant={"link"}
            className="text-red-700 underline"
            onClick={handleManualRedirect}
          >
            {t("click_here")}
          </Button>
        </Typography>
      </div>
    </div>
  );
};
